// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Folder, FolderPlus } from 'lucide-react';

export default function FolderSelector({
  folders,
  selectedFolderId,
  setSelectedFolderId,
  showNewFolder,
  setShowNewFolder,
  newFolderName,
  setNewFolderName,
  creatingFolder,
  onCreateFolder,
}) {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">Pasta de destino</Label>
      <div className="flex gap-2">
        <Select value={selectedFolderId} onValueChange={setSelectedFolderId}>
          <SelectTrigger className="flex-1" data-testid="folder-select">
            <SelectValue placeholder="Selecione uma pasta" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="root">
              <div className="flex items-center gap-2">
                <Folder className="w-4 h-4" />
                Raiz (/)
              </div>
            </SelectItem>
            {folders.map((folder) => (
              <SelectItem key={folder.id} value={folder.id}>
                <div className="flex items-center gap-2">
                  <Folder className="w-4 h-4" />
                  {folder.displayName || folder.name}
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={() => setShowNewFolder(!showNewFolder)}
          data-testid="new-folder-toggle"
        >
          <FolderPlus className="w-4 h-4" />
        </Button>
      </div>

      {showNewFolder && (
        <div className="flex gap-2 mt-2">
          <Input
            placeholder="Nome da nova pasta"
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
            data-testid="new-folder-name"
          />
          <Button
            type="button"
            onClick={onCreateFolder}
            disabled={creatingFolder || !newFolderName.trim()}
            data-testid="create-folder-btn"
          >
            {creatingFolder ? 'Criando...' : 'Criar'}
          </Button>
        </div>
      )}
    </div>
  );
}
